<template>
  <div
    v-loading="loading"
    v-html="rawHtml"
  />
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      rawHtml: null,
      loading: false,
    };
  },
  // watch: {
  //   url: {
  //     immediate: false,
  //     handler(url) {
  //       if (url && url.length) {
  //         this.fetchHtml(url);
  //       }
  //     },
  //   },
  // },
  created() {
    if (this.url && this.url.length && !this.rawHtml) {
      this.fetchHtml(this.url);
    }
  },
  methods: {
    fetchHtml(url) {
      this.loading = true;
      this.$http.get(url)
        .then(({ data }) => {
          this.rawHtml = data;
          this.loading = false;
        }, () => {
          this.loading = false;
          this.$message(this.$t('No content found'));
        });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ContentPage/HtmlLoader.vue